import React, { useState } from 'react'
import { AxiosError } from 'axios'
import AttachmentService from '../../services/AttachmentService'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'
import DebriefingService from '../../services/DebriefingService';
import IDebriefingData from '../../types/Debriefing';

export interface DataStoreDebriefing extends IDebriefingData {
    appraiser_id: string;
    status: 'not_corrected';
}

export function useUploadFile() {

    const { t } = useTranslation()

    const [ loadingUploadFile, setLoadingUploadFile ] = useState(false)
    const [ successUploadFile, setSuccessUploadFile ] = useState(false)
    const [ errorUploadFile, setErrorUploadFile ] = useState(false)
    const [ fileUploaded, setFileUploaded ] = useState<{name:string, url:string} | null>(null)

    const uploadFileDebriefing = async (
        e: React.ChangeEvent<HTMLInputElement>,
        debriefing_id: number | string,
        ids?: Pick<IDebriefingData, 'event_id' | 'station_id' | 'evaluated_id'>,
    ) => {

        const file = e.target.files?.[0]
        if (!file) return

        const data = {
          feature: 'debriefing',
          object_id: debriefing_id,
          field_name: 'debriefing_video',
          file,
          file_type: 'video',
          multiple: 'false',
          // O backend precisa da tripla para montar o caminho no GCS; sem ela
          // o upload falha com HTTP 400 e o vídeo nunca chega ao bucket.
          ...(ids ? {
            event_id: ids.event_id,
            station_id: ids.station_id,
            user_id: ids.evaluated_id,
          } : {}),
        }

        try {
            const response = await AttachmentService.upload(data)
            
            toast(t('toast_load_video'), {
                type: 'success',
            })

            setFileUploaded({
                name: file.name,
                url: response.data.url,
            })
        } catch (error: unknown) {
            setErrorUploadFile(true)
            const msg = error instanceof AxiosError
                ? error.response?.data?.Error
                : t('toast_load_video_error')
            toast(msg, {
                type: 'error',
            })
        }finally {
            setLoadingUploadFile(false)
        }
    
    }

    const storeDebriefing = async (
        event: React.ChangeEvent<HTMLInputElement>,
        data: DataStoreDebriefing
      ) => {

        setLoadingUploadFile(true)
        setSuccessUploadFile(false)
        setErrorUploadFile(false)

        if (event.target.files !== null && event.target.files[0].type != 'video/mp4') {
          toast(t('toast_type_video'), {
            type: 'error',
          })
          return
        }

        try {
            const response = await DebriefingService.store(data)
            if (response.data) {
                const debriefing_id = response.data.debriefing_id
                // Repassa a tripla: é o que o backend usa para montar o caminho
                // no GCS, e é ela que faz a notificação do bucket disparar a
                // análise da IA automaticamente.
                uploadFileDebriefing(event, debriefing_id, {
                    event_id: data.event_id,
                    station_id: data.station_id,
                    evaluated_id: data.evaluated_id,
                })
            }
        } catch (error) {
            setErrorUploadFile(true)
        }
    }

    return {
        uploadFileDebriefing,
        storeDebriefing,
        setFileUploaded,
        fileUploaded,
        loadingUploadFile,
        successUploadFile,
        errorUploadFile,
    }
}
